export const CONNECTION_POSITIONS = ["TopLeft", "TopRight", "BottomLeft", "BottomRight", "Front", "Back"];
export const CONNECTION_TYPES = ["Not Required", "PVC", "StormPro", "RCP", "Flanged"];
export const RISER_TYPES = ["600mm Dia", "600x600mm", "600x900mm Along", "600x900mm Across", "900x900mm", "600x1200mm Along", "600x1200mm Across", "900x1200mm Along", "900x1200mm Across", "1200x1200mm"];
export const locationKey = (position) => `${position}Connection${["Front", "Back"].includes(position) ? "FromLeft" : "IL"}`;
export const DEFAULT_HYDROVAULT_CONFIG = {
    TankDia: 2500, TankLength: 23010, FSL: 76, Suspended: "Yes",
    RiserType: "600x900mm Along", RiserQty: 3, RiserHeight: 800,
    LidClass: "Class D", AdditionalRiserVents: "No", VentLocation: "C", VentSize: "100",
    ...Object.fromEntries(CONNECTION_POSITIONS.flatMap((position) => {
        const enabled = position.startsWith("Top");
        return [[`${position}ConnectionType`, enabled ? "PVC" : "Not Required"],
            [`${position}ConnectionSize`, enabled ? 300 : null], [locationKey(position), enabled ? 73.11 : null]];
    })),
};

// Preserve the exact Inventor contract: dimensions in mm, levels in m and unused values null.
export function toHydrovaultParameters(config) {
    const parameters = Object.fromEntries(Object.keys(DEFAULT_HYDROVAULT_CONFIG).map((key) => [key, config[key]]));
    parameters.VentSize = String(parameters.VentSize);
    CONNECTION_POSITIONS.forEach((position) => {
        if (parameters[`${position}ConnectionType`] === "Not Required") {
            parameters[`${position}ConnectionSize`] = null;
            parameters[locationKey(position)] = null;
        }
    });
    return parameters;
}

export function validateHydrovault(config) {
    const errors = {};
    const numeric = (key) => typeof config[key] === "number" && Number.isFinite(config[key]);
    ["TankLength", "RiserQty", "RiserHeight"].forEach((key) => {
        if (!numeric(key) || config[key] <= 0 || config[key] > 1000000) errors[key] = "Enter a positive number up to 1,000,000.";
    });
    if (!Number.isInteger(config.RiserQty)) errors.RiserQty = "Enter a whole number.";
    if (!numeric("FSL")) errors.FSL = "Enter a finish surface level.";
    if (!/^\d+$/.test(String(config.VentSize)) || +config.VentSize <= 0 || +config.VentSize > 1000) errors.VentSize = "Enter a whole number from 1 to 1000.";
    CONNECTION_POSITIONS.forEach((position) => {
        if (config[`${position}ConnectionType`] === "Not Required") return;
        const size = `${position}ConnectionSize`;
        const level = locationKey(position);
        if (!numeric(size) || config[size] <= 0 || config[size] > 1000000) errors[size] = "Enter a positive connection size.";
        if (!numeric(level)) errors[level] = "Enter a value.";
        else if (["Front", "Back"].includes(position)) {
            if (config[level] < 0 || config[level] > config.TankLength) errors[level] = "Must be within the tank length.";
        } else if (config[level] >= config.FSL) errors[level] = "Invert level must be below FSL.";
    });
    return errors;
}
